<template lang="pug">
  .pos-list(v-if='posData')
    .pos-item(v-for='pos in orderedPosList' :key='pos.Id' :class="{'is-active': pos.Id === selected}" @click='setPos(pos)')
      div.pos-item__inner
        p
          span.pos-name.color-brand Cơ sở {{pos.Pos_Name}}
          span.color-secondary(v-if="pos.Distance && type!=='PICK'") {{ pos.Distance }}km
        svg(width='19' height='17' viewbox='0 0 19 17' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M10.7045 1.28401C10.3111 0.896392 9.678 0.901082 9.2904 1.29449C8.9027 1.68789 8.9074 2.32104 9.3008 2.70866L14.6712 8.00006H1C0.44771 8.00006 0 8.44776 0 9.00006C0 9.55236 0.44772 10.0001 1 10.0001H14.6646L9.3008 15.285C8.9074 15.6726 8.9027 16.3058 9.2904 16.6992C9.678 17.0926 10.3111 17.0973 10.7045 16.7096L17.6287 9.88716C18.1256 9.39756 18.1256 8.59596 17.6287 8.10636L10.7045 1.28401Z' fill='#ADA8A8')
</template>
<script>
  import _ from 'lodash';
  import { bus } from '../main'
  export default {
    name: 'PosList',
    props: {
      posData: Array,
      location: Object,
      type: String,
    },
    data () {
      return {
        selected : null,
      }
    },
    created () {
    },
    methods: {
      setPos(pos) {
        this.selected = pos.Id || null;
        this.$store.dispatch('restaurants/setSelected', pos.Id)
        this.$store.dispatch('shipments/setType', this.type || 'DELI')
        bus.$emit('changeShipmentType', this.type)
        this.$store.dispatch('shipments/setSelecting', false)

      },
    },
    computed: {
      orderedPosList: function () {
        if (this.location) {
          let arr = this.posData, current = this.selectedRestaurant, calc;
          if (arr) {
            let loc = this.location;
            const rad = function (x) {
              return x * Math.PI / 180;
            };

            arr.forEach(function (e, i) {
              const p1 = {
                lng: e.Pos_Longitude,
                lat: e.Pos_Latitude,
              };
              const p2 = loc;
              const R = 6378137; // Earth’s mean radius in meter
              const dLat = rad(p2.lat - p1.lat);
              const dLong = rad(p2.lng - p1.lng);
              const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);
              const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
              const d = R * c / 1000;
              arr[i].Distance = parseFloat(d.toFixed(2));
              if (current && arr[i].Id === current.pos.Id) {
                calc = arr[i]
              }
            })
          }
          //if (calc) this.$emit('initPos', calc)
          return _.orderBy(arr, 'Distance')
        } else {
          return  this.posData
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/PosList.vue